import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

const GALLERY_IDS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
];

function loadOrientation(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const landscape = img.naturalWidth >= img.naturalHeight;
      resolve({ src, landscape, w: img.naturalWidth, h: img.naturalHeight });
    };
    img.onerror = () => resolve({ src, landscape: true, w: 0, h: 0 });
    img.src = src;
  });
}

function Gallery() {
  const [items, setItems] = useState(
    GALLERY_IDS.map((id) => ({
      src: `/assets/images/gallery/${id}.webp?v=20260924`,
      landscape: true,
    }))
  );

  useEffect(() => {
    let cancelled = false;
    Promise.all(
      GALLERY_IDS.map((id) =>
        loadOrientation(`/assets/images/gallery/${id}.webp?v=20260924`)
      )
    ).then((results) => {
      if (cancelled) return;
      const landscape = results.filter((r) => r.landscape);
      const portrait = results.filter((r) => !r.landscape);
      setItems([...landscape, ...portrait]);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg"></div>
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <span>Gallery</span>
              </li>
            </ul>
            <h2 className="page-header__title">Gallery</h2>
          </div>
        </section>

        <section className="gallery-one gallery-one--page">
          <div className="container">
            <div className="row">
              {items.map((item) => (
                <div className="col-md-6 col-lg-3" key={item.src}>
                  <div
                    className={`gallery-one__card${
                      item.landscape ? " is-landscape" : " is-portrait"
                    }`}
                  >
                    <img src={item.src} alt="Hanthana House gallery" />
                    <div className="gallery-one__card__hover">
                      <a href={item.src} className="img-popup" target="_blank" rel="noreferrer">
                        <span className="gallery-one__card__icon"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Gallery;
